export default "__VITE_ASSET__BLYsM6hd__"